var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "table-wrp block sm:max-h-1/2 h-80 bg-white overflow-y-scroll scrollbar overflow-x-hidden rounded-lg font-sans",
    },
    [
      _vm.manager.length > 0
        ? _c(
            "table",
            {
              staticClass: "w-full max-h-full min-w-max table-auto",
              attrs: { rounded: "", "aria-label": "managers table" },
            },
            [
              _c(
                "thead",
                {
                  staticClass:
                    "bg-blue-100 text-gray-600 text-md rounded-xl border-b sticky top-0 z-10",
                },
                [
                  _c(
                    "tr",
                    {
                      staticClass:
                        "bg-blue-100 text-gray-600 text-md rounded-xl",
                    },
                    [
                      _c("th", { staticClass: "py-1 pl-5 text-left text-sm" }, [
                        _vm._v("Manager"),
                      ]),
                      _vm.isManager
                        ? _c(
                            "th",
                            { staticClass: "py-1 px-1 text-left text-sm" },
                            [_vm._v("Title")]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "th",
                            { staticClass: "py-1 px-1 text-left text-sm" },
                            [_vm._v(" Completed Clients ")]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "th",
                            { staticClass: "py-1 px-1 text-left text-sm" },
                            [_vm._v(" In Progress ")]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "th",
                            { staticClass: "py-1 px-1 text-left text-sm" },
                            [_vm._v(" Contractor Requests ")]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c("th", {
                            staticClass: "py-1 px-1 text-left text-sm",
                          })
                        : _vm._e(),
                      _vm.isManager
                        ? _c("th", {
                            staticClass: "py-1 px-1 text-left text-sm",
                          })
                        : _vm._e(),
                      _vm.isManager
                        ? _c("th", {
                            staticClass: "py-1 px-1 text-left text-sm",
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._l(_vm.manager, function (resource) {
                return _c(
                  "tbody",
                  {
                    key: resource.id,
                    staticClass:
                      "text-gray-800 text-sm font-light border-b border-gray-200",
                  },
                  [
                    _vm.currentUserId !== resource.user.id
                      ? _c("tr", {}, [
                          _c(
                            "td",
                            {
                              staticClass:
                                "py-2 px-1 text-left w-full overflow-hidden cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.viewProfile(resource)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-row" },
                                [
                                  resource.user.avatar
                                    ? [
                                        _vm._t(
                                          "image flex-shrink-0 span-fix mt-2.5",
                                          function () {
                                            return [
                                              _c("S3Image", {
                                                staticClass: "mt-2",
                                                class: [
                                                  _vm.defaultImageClasses,
                                                  _vm.avatarStyleClasses,
                                                ],
                                                attrs: {
                                                  s3FileKey:
                                                    resource.user.avatar,
                                                },
                                              }),
                                            ]
                                          },
                                          {
                                            defaultClasses: [
                                              _vm.defaultImageClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            image: resource.user.avatar,
                                          }
                                        ),
                                      ]
                                    : [
                                        _vm._t(
                                          "initial",
                                          function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    _vm.defaultInitialsClasses,
                                                    _vm.avatarStyleClasses,
                                                  ],
                                                  style: _vm.bgStyle,
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-xs leading-none font-semibold text-white",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          resource.user.given_name
                                                            .trimStart()[0]
                                                            .toUpperCase()
                                                        ) +
                                                          _vm._s(
                                                            resource.user.family_name
                                                              .trimStart()[0]
                                                              .toUpperCase()
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          {
                                            defaultClasses: [
                                              _vm.defaultInitialsClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                          }
                                        ),
                                      ],
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ml-1.5 mt-2.5 overflow-hidden whitespace-nowrap text-xs",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(resource.user.given_name) +
                                          " " +
                                          _vm._s(resource.user.family_name) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm.isManager
                            ? _c(
                                "td",
                                {
                                  staticClass: "py-2 px-1 text-left",
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewProfile(resource)
                                    },
                                  },
                                },
                                [
                                  resource.user.profile.job_title
                                    ? _c("p", { staticClass: "mt-2.5" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              resource.user.profile.job_title
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("p", { staticClass: "mt-2.5" }, [
                                        _vm._v("N/A"),
                                      ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "td",
                                {
                                  staticClass: "py-2 px-1 text-left",
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewProfile(resource)
                                    },
                                  },
                                },
                                [
                                  _c("p", { staticClass: "mt-2.5 text-xs" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          resource.projects_aggregate.aggregate
                                            .count
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "td",
                                {
                                  staticClass: "py-2 px-1 text-left text-xs",
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewProfile(resource)
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "mt-2.5 text-xs" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            resource.uncompleted_projects
                                              .aggregate.count
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 text-left text-blue-500 relative",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex -pt-8" },
                                    [
                                      _c("p", { staticClass: "mt-3 text-xs" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              resource.contractors_aggregate
                                                .aggregate.count
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      resource.contractors_aggregate.aggregate
                                        .count !== 0
                                        ? _c(
                                            "p",
                                            {
                                              staticClass: "flex mt-2.5 ml-0.5",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShow(
                                                    resource
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: "#" } },
                                                [
                                                  !_vm.modalDisplay
                                                    ? _c(
                                                        "svg",
                                                        {
                                                          staticClass: "mt-2.5",
                                                          attrs: {
                                                            width: "10",
                                                            height: "6",
                                                            viewBox: "0 0 10 6",
                                                            fill: "none",
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M0.387341 2.23408L3.77112 5.61786C4.28065 6.12738 5.10373 6.12738 5.61325 5.61786L8.99703 2.23408C9.82011 1.411 9.2322 0 8.06943 0H1.30188C0.13911 0 -0.43574 1.411 0.387341 2.23408Z",
                                                              fill: "#1A7BEE",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.modalDisplay
                                                    ? _c(
                                                        "svg",
                                                        {
                                                          staticClass: "mt-2.5",
                                                          attrs: {
                                                            width: "10",
                                                            height: "6",
                                                            viewBox: "0 0 10 6",
                                                            fill: "none",
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M8.99547 3.76592L5.61169 0.382145C5.10217 -0.127381 4.27909 -0.127381 3.76956 0.382145L0.385782 3.76592C-0.437299 4.589 0.150616 6 1.31338 6L8.08094 6C9.2437 6 9.81855 4.589 8.99547 3.76592Z",
                                                              fill: "#1A7BEE",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "RouterLink",
                                        { attrs: { to: _vm.itemLink } },
                                        [
                                          resource.contractors_aggregate
                                            .aggregate.count > 0
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "ml-3 mt-3 flex text-xs",
                                                },
                                                [_vm._v(" Approve ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c("td", { staticClass: "py-2 pl-1 text-left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex item-left justify-left",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-4 mr-2 transform hover:text-purple-500 hover:scale-110 cursor-pointer",
                                        on: {
                                          click: function ($event) {
                                            return _vm.message(resource)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              width: "14",
                                              height: "14",
                                              viewBox: "0 0 13 12",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M10.9612 0H1.21791C0.54806 0 0.00608955 0.54 0.00608955 1.2L0 12L2.43582 9.6H10.9612C11.631 9.6 12.1791 9.06 12.1791 8.4V1.2C12.1791 0.54 11.631 0 10.9612 0ZM9.13433 7.2H3.04478C2.70985 7.2 2.43582 6.93 2.43582 6.6C2.43582 6.27 2.70985 6 3.04478 6H9.13433C9.46925 6 9.74328 6.27 9.74328 6.6C9.74328 6.93 9.46925 7.2 9.13433 7.2ZM9.13433 5.4H3.04478C2.70985 5.4 2.43582 5.13 2.43582 4.8C2.43582 4.47 2.70985 4.2 3.04478 4.2H9.13433C9.46925 4.2 9.74328 4.47 9.74328 4.8C9.74328 5.13 9.46925 5.4 9.13433 5.4ZM9.13433 3.6H3.04478C2.70985 3.6 2.43582 3.33 2.43582 3C2.43582 2.67 2.70985 2.4 3.04478 2.4H9.13433C9.46925 2.4 9.74328 2.67 9.74328 3C9.74328 3.33 9.46925 3.6 9.13433 3.6Z",
                                                fill: "#1A7BEE",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    resource.status != "SUSPENDED"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-4 mr-2 transform hover:text-purple-500 hover:scale-110 mt-3 cursor-pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.disablee(resource)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "14",
                                                  alt: "Suspend",
                                                  height: "14",
                                                  viewBox: "0 0 14 14",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M6.98751 0.000129044C10.8061 -0.0230934 13.9889 3.0909 14.0007 6.97834C14.0124 10.8385 10.8659 13.9945 7.00964 14C3.14187 14.0057 0.00492343 10.8633 5.73572e-06 6.98736C-0.00491196 3.13871 3.15307 -0.0113456 6.98751 0.000129044ZM11.9743 6.98763C11.9762 6.07266 11.7383 5.21016 11.2678 4.42879C11.164 4.25612 11.1637 4.25612 11.0255 4.39436C9.95042 5.46915 8.87563 6.54422 7.80084 7.61901C6.66157 8.75827 5.52231 9.89754 4.38304 11.0368C4.25873 11.1611 4.25818 11.163 4.41227 11.254C5.53405 11.9152 6.73834 12.1359 8.0123 11.8709C10.3416 11.3865 11.9689 9.3678 11.9743 6.98763ZM2.01025 7.01905C2.01216 7.06003 2.01271 7.10101 2.01599 7.14172C2.01954 7.18707 2.02801 7.23215 2.02992 7.2775C2.06407 8.10559 2.31569 8.86674 2.73534 9.57598C2.83014 9.73608 2.83096 9.7358 2.95909 9.60767C5.17697 7.38979 7.39458 5.17218 9.61246 2.9543C9.73841 2.82835 9.73841 2.82753 9.58569 2.73847C8.71116 2.22812 7.77379 1.97622 6.7561 2.02595C6.15751 2.05518 5.57777 2.16883 5.03709 2.42046C3.08531 3.32832 2.10724 4.88559 2.01025 7.01905Z",
                                                    fill: "#1A7BEE",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    resource.status == "SUSPENDED"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-4 mr-2 transform hover:text-purple-500 hover:scale-110 cursor-pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeNote(resource)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "mt-2.5",
                                                attrs: {
                                                  width: "11",
                                                  height: "14",
                                                  viewBox: "0 0 11 14",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M0.886667 12.25C0.886667 13.2125 1.68467 14 2.66 14H7.98C8.95533 14 9.75333 13.2125 9.75333 12.25V3.5H0.886667V12.25ZM9.75333 0.875H7.98L7.35047 0.25375C7.19087 0.09625 6.96033 0 6.7298 0H3.9102C3.67967 0 3.44913 0.09625 3.28953 0.25375L2.66 0.875H0.886667C0.399 0.875 0 1.26875 0 1.75C0 2.23125 0.399 2.625 0.886667 2.625H9.75333C10.241 2.625 10.64 2.23125 10.64 1.75C10.64 1.26875 10.241 0.875 9.75333 0.875Z",
                                                    fill: "#1A7BEE",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isManager
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "py-2 px-1 pr-12 text-left whitespace-nowrap flex-row w-full cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewProfile(resource)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex item-left justify-left w-6 mr-2 transform hover:text-purple-500 hover:scale-110",
                                    },
                                    [
                                      [
                                        _vm._t("actions", function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.defaultInitialsClasses,
                                                ],
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-sm leading-none text-white",
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass: "mt-0",
                                                        attrs: {
                                                          width: "14",
                                                          height: "14",
                                                          viewBox: "0 0 21 14",
                                                          fill: "none",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M10.2558 0C5.59408 0 1.61296 2.90267 0 7C1.61296 11.0973 5.59408 14 10.2558 14C14.9175 14 18.8987 11.0973 20.5116 7C18.8987 2.90267 14.9175 0 10.2558 0ZM10.2558 11.6667C7.68254 11.6667 5.59408 9.576 5.59408 7C5.59408 4.424 7.68254 2.33333 10.2558 2.33333C12.8291 2.33333 14.9175 4.424 14.9175 7C14.9175 9.576 12.8291 11.6667 10.2558 11.6667ZM10.2558 4.2C8.70812 4.2 7.45877 5.45067 7.45877 7C7.45877 8.54933 8.70812 9.8 10.2558 9.8C11.8035 9.8 13.0529 8.54933 13.0529 7C13.0529 5.45067 11.8035 4.2 10.2558 4.2Z",
                                                            fill: "#1A7BEE",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        }),
                                      ],
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "ml-1.5 mt-2.5 flex-shrink-0 span-fix text-xs",
                                        },
                                        [_vm._v(" View Profile ")]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.isManager
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "py-2 px-7 pr-10 text-left whitespace-nowrap flex-row w-full cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.message(resource)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex item-left justify-left w-10 mr-2 transform hover:text-purple-500 hover:scale-110",
                                    },
                                    [
                                      [
                                        _vm._t("actions", function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.defaultInitialsClasses,
                                                ],
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-sm leading-none text-white",
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass: "mt-0.5",
                                                        attrs: {
                                                          width: "14",
                                                          height: "14",
                                                          viewBox: "0 0 13 12",
                                                          fill: "none",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M10.9612 0H1.21791C0.54806 0 0.00608955 0.54 0.00608955 1.2L0 12L2.43582 9.6H10.9612C11.631 9.6 12.1791 9.06 12.1791 8.4V1.2C12.1791 0.54 11.631 0 10.9612 0ZM9.13433 7.2H3.04478C2.70985 7.2 2.43582 6.93 2.43582 6.6C2.43582 6.27 2.70985 6 3.04478 6H9.13433C9.46925 6 9.74328 6.27 9.74328 6.6C9.74328 6.93 9.46925 7.2 9.13433 7.2ZM9.13433 5.4H3.04478C2.70985 5.4 2.43582 5.13 2.43582 4.8C2.43582 4.47 2.70985 4.2 3.04478 4.2H9.13433C9.46925 4.2 9.74328 4.47 9.74328 4.8C9.74328 5.13 9.46925 5.4 9.13433 5.4ZM9.13433 3.6H3.04478C2.70985 3.6 2.43582 3.33 2.43582 3C2.43582 2.67 2.70985 2.4 3.04478 2.4H9.13433C9.46925 2.4 9.74328 2.67 9.74328 3C9.74328 3.33 9.46925 3.6 9.13433 3.6Z",
                                                            fill: "#1A7BEE",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        }),
                                      ],
                                      _c(
                                        "p",
                                        {
                                          staticClass: "ml-1.5 mt-2.5 text-xs",
                                        },
                                        [_vm._v("Message")]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.modalDisplay && resource.user.id === _vm.selectedId
                      ? _c(
                          "tr",
                          { staticClass: "flex w-full" },
                          _vm._l(
                            resource.contractors,
                            function (contractorInfo) {
                              return _c("div", { key: contractorInfo.id }, [
                                contractorInfo.contractor.deleted === false
                                  ? _c("div", { staticClass: "pl-8" }, [
                                      _c("p", [
                                        _vm._v(
                                          " Contractor: " +
                                            _vm._s(
                                              contractorInfo.contractor.user
                                                .given_name
                                            ) +
                                            "  " +
                                            _vm._s(
                                              contractorInfo.contractor.user
                                                .family_name
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }